/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information.
 *
 * The version of the OpenAPI document: 0.2.2
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  JobId,
  RoutePost,
  RouteResponse,
} from '../models';
import {
    JobIdFromJSON,
    JobIdToJSON,
    RoutePostFromJSON,
    RoutePostToJSON,
    RouteResponseFromJSON,
    RouteResponseToJSON,
} from '../models';

export interface ShipRouteExecutePostRequest {
    json: RoutePost;
}

export interface ShipRouteIdGetRequest {
    id: number;
}

export interface ShipRoutePostRequest {
    json: RoutePost;
}

/**
 * 
 */
export class RouteApi extends runtime.BaseAPI {

    /**
     * Perform route calculation. This function combines /route/start and polling /route/result until completed. The function will thus block for the duration of the route calculation, which can be a couple of minutes.
     * Perform route calculation in one operation
     */
    async shipRouteExecutePostRaw(requestParameters: ShipRouteExecutePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RouteResponse>> {
        if (requestParameters.json === null || requestParameters.json === undefined) {
            throw new runtime.RequiredError('json','Required parameter requestParameters.json was null or undefined when calling shipRouteExecutePost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/ship/route/execute`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RoutePostToJSON(requestParameters.json),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RouteResponseFromJSON(jsonValue));
    }

    /**
     * Perform route calculation. This function combines /route/start and polling /route/result until completed. The function will thus block for the duration of the route calculation, which can be a couple of minutes.
     * Perform route calculation in one operation
     */
    async shipRouteExecutePost(requestParameters: ShipRouteExecutePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RouteResponse> {
        const response = await this.shipRouteExecutePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Once the job has been completed (or aborted) and result given back the job is deleted. The operation will timeout if not completed in two minutes.
     * Query / poll result by identifier
     */
    async shipRouteIdGetRaw(requestParameters: ShipRouteIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RouteResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling shipRouteIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/ship/route/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RouteResponseFromJSON(jsonValue));
    }

    /**
     * Once the job has been completed (or aborted) and result given back the job is deleted. The operation will timeout if not completed in two minutes.
     * Query / poll result by identifier
     */
    async shipRouteIdGet(requestParameters: ShipRouteIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RouteResponse> {
        const response = await this.shipRouteIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Start route calculation from \'source\' to \'destination\'. A route is calculated (if possible) and a set of waypoint positions are returned. The \'source\' and \'destination\' parameters must each define either a \'port\', \'ship\' or \'position\'. The \'port\' can be either a \'port id\' or a \'port locode\' or a \'port name\'. A ship can be one or more of a MMSI, IMO number, shipname or callsign. A \'position\' is a GEOJSON formatted point. If a ship is used then the draught of the ship is used in the calculations (if available). The draught can be overridden by applying a draught parameter in the \'source\'. The function returns an identifier. Subsequently call /route/result using the identifier to obtain the result.
     * Start route calculation from source to destination.
     */
    async shipRoutePostRaw(requestParameters: ShipRoutePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<JobId>> {
        if (requestParameters.json === null || requestParameters.json === undefined) {
            throw new runtime.RequiredError('json','Required parameter requestParameters.json was null or undefined when calling shipRoutePost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/ship/route`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RoutePostToJSON(requestParameters.json),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => JobIdFromJSON(jsonValue));
    }

    /**
     * Start route calculation from \'source\' to \'destination\'. A route is calculated (if possible) and a set of waypoint positions are returned. The \'source\' and \'destination\' parameters must each define either a \'port\', \'ship\' or \'position\'. The \'port\' can be either a \'port id\' or a \'port locode\' or a \'port name\'. A ship can be one or more of a MMSI, IMO number, shipname or callsign. A \'position\' is a GEOJSON formatted point. If a ship is used then the draught of the ship is used in the calculations (if available). The draught can be overridden by applying a draught parameter in the \'source\'. The function returns an identifier. Subsequently call /route/result using the identifier to obtain the result.
     * Start route calculation from source to destination.
     */
    async shipRoutePost(requestParameters: ShipRoutePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<JobId> {
        const response = await this.shipRoutePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
